module.exports = __webpack_public_path__ + "static/media/2019_IMG_2026.1f8956f3.jpg";